import { motion } from "framer-motion";
import { Star, Shield } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const STAMPS = [
  { key: "twc", Icon: Star, tone: "text-brand", iconCls: "fill-brand text-brand" },
  { key: "tefa", Icon: Star, tone: "text-brick", iconCls: "fill-brick text-brick" },
  { key: "military", Icon: Shield, tone: "text-ink", iconCls: "fill-ink/10 text-ink" },
];

const STRIP_MOTION = { initial: { opacity: 0, y: -10 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6, delay: 0.1 } };

export const AcceptanceStamps = () => {
  const { t } = useLang();
  const copy = t("home.stamps");
  return (
    <motion.div {...STRIP_MOTION}
      className="mx-auto grid w-fit max-w-full grid-cols-1 divide-y divide-brand/30 rounded-2xl border-2 border-brand/60 bg-white/90 shadow-sm backdrop-blur sm:grid-cols-3 sm:divide-x sm:divide-y-0"
      data-testid="hero-stamps" role="list">
      {STAMPS.map(({ key, Icon, tone, iconCls }) => (
        <div key={key} role="listitem" data-testid={`hero-stamp-${key}`}
          className="flex items-center gap-3 px-5 py-3 sm:px-7">
          <Icon className={`h-6 w-6 shrink-0 ${iconCls}`} />
          <div className="leading-none">
            <p className={`font-display text-[11px] font-bold uppercase tracking-wide ${tone}`}>{copy[key].top}</p>
            <p className={`mt-0.5 font-display text-2xl font-extrabold leading-none ${tone}`}>{copy[key].big}</p>
            <p className={`mt-0.5 font-display text-xs font-bold uppercase tracking-wide ${tone}`}>{copy[key].bottom}</p>
            {copy[key].note && <p className="mt-1 font-mono text-[9px] uppercase tracking-widest text-mist">{copy[key].note}</p>}
          </div>
        </div>
      ))}
    </motion.div>
  );
};
